import Header5_2 from './Header5_2'
export default Header5_2
